/**
 * @file matchprocess.js
 * @description 匹配状态
 */

/**
 * 匹配问答帖子官方流程对应状态
 *
 * @param {string} process 官方流程状态字符
 * @return {string} 官方流程状态中文
 */
export const matchOfficialProcess = process => {
    switch (process) {
        case 'OP_PENDING': return '待解决';
        case 'OP_PROCESSING': return '处理中';
        case 'OP_SOLVED': return '已解决';
        default: return process;
    }
};

/**
 * 最大评论数、回复数、点赞数限制
 *
 * @param {number} num 数字
 * @return {*}
 */
export const limitMaxNum = num => (num > 99999 ? '99999+' : num);
